import React, { FC } from "react";
import { useLocation } from "react-router-dom";

import AuthFlowLayout from "../../layouts/AuthFlowLayout";
import BrandAuthLayout from "../../layouts/BrandAuthLayout";
import ConfirmVerificationCodeForm from "./components/ConfirmVerificationCodeForm";
import RedesignedConfirmVerificationCodeForm from "./components/RedesignedConfirmVerificationCodeForm";
import RedesignedSignUpForm from "./components/RedesignedSignUpForm";
import SignUpForm from "./components/SignUpForm";

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

const SignUpPage: FC = () => {
  const location = useLocation();
  const { userName } = Object.fromEntries(new URLSearchParams(location.search));

  if (useNewDesign) {
    return (
      <BrandAuthLayout
        heading="Join BrandGen.io"
        description="Create account: to view your personalized dashboard, campaigns, and audiences."
      >
        {userName ? <RedesignedConfirmVerificationCodeForm userName={userName} /> : <RedesignedSignUpForm />}
      </BrandAuthLayout>
    );
  }

  return (
    <AuthFlowLayout
      heading="Join BrandGen.io"
      description="Create account: to view your personalized dashboard, campaigns, and audiences."
    >
      {userName ? <ConfirmVerificationCodeForm userName={userName} /> : <SignUpForm />}
    </AuthFlowLayout>
  );
};

export default SignUpPage;
